// extracted by css-extract-rspack-plugin
export default {"Box":"delete-field-dialog-module__Box__qEmrN9D","Text":"delete-field-dialog-module__Text__vxLuY1G"};